// export const main_api = 'https://skycinema-server-production-a783.up.railway.app'
// export const main_api = 'https://skycinema-new-server-production.up.railway.app'
// export const main_api = 'https://skycinema-back-production.up.railway.app'
export const main_api = 'https://skycinema-back-production.up.railway.app'

